import React from 'react';
import {
  IDataModelAddFieldInput,
  IDataModelExtendFactFieldInput,
  ITableFieldFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import {
  TablesListDictionaryCell,
  TablesListDictionaryCellItem,
} from '../DataModelerCommonUI';
import { shortTableKey } from '../utils';

interface IProps {
  schemaKey: string;
  existing: ITableFieldFieldsFragment[];
  added: IDataModelAddFieldInput | null;
  extended: IDataModelExtendFactFieldInput[];
  isBold: boolean;
}

const DataModelerFieldGridTableColumns = ({
  schemaKey,
  existing,
  added,
  extended,
  isBold,
}: IProps) => {
  // XXX these all have a tableKey and column
  const addedList = added ? [added] : [];
  const all = [...existing, ...addedList, ...extended];
  return (
    <TablesListDictionaryCell $isBold={isBold}>
      {all.map((item) => {
        const columnStr = `${shortTableKey(schemaKey, item.tableKey)}.${
          item.column
        }`;
        return (
          <TablesListDictionaryCellItem key={columnStr}>
            {columnStr}
          </TablesListDictionaryCellItem>
        );
      })}
    </TablesListDictionaryCell>
  );
};

export default DataModelerFieldGridTableColumns;
